import { slice } from "lodash";
import { DEBUG } from "../../../config";
import { sleep } from "../../../lib/gramjs/Helpers";

class FunctionQueue {
    public queue: Array<{ func: Function, args: any[] }> = [];
    private running: boolean = false;

    public async enqueue(func: Function, ...args: any[]): Promise<void> {
        this.queue.push({ func, args });
       
        
        if (!this.running) {
            this.running = true;
            await this.executeNext();
        }
    }

    private async executeNext(): Promise<void> {
        while (this.queue.length > 0) {
            await sleep(100); // Chờ 100ms giây trước khi thực hiện lời gọi tiếp theo, phải để ở đây
            const { func, args } = this.queue.shift()!;            
            
            await func(...args);

            if (DEBUG)
                console.log(`${new Date().toISOString()} ${func.name} sau khi thuc hien call phân tích. length= ${this.queue.length}`)

        }
        this.running = false; // Cập nhật biến running sau khi hoàn thành tất cả các lời gọi
    }
}
export const functionQueue = new FunctionQueue();


